<script>
    /**
     * 标签
     */
    import CheckBox from './CheckBox.vue';
    import NormalLabel from './NormalLabel.vue';

    export default {
        name: 'check-box-group',
        componentName: 'CheckBoxGroup',
        props: {
            value: {},
            theme: {
                default: 'grey',
                required: false
            },
            icon: {
                default: '',
                required: false
            },
            marginLeft: {
                default: 0,
                required: false
            },
            marginRight: {
                default: 0,
                required: false
            },
            float: {
                default: 'left',
                required: false
            },
            disabled: {
                type: Boolean,
                default: false,
                required: false
            },
            textWidth: {
                default: -1,
                required: false
            },
            shape: {
                default: 'square',
                required: false
            },
            data: {
                required: false,
                type: Object
            },
            forceHideOrShow: {
                default: '',
                required: false
            }
        },
        model: {
            prop: 'value',
            event: 'check'
        },
        data () {
            let isHideOrShowOpts = false;
            let tempMap = [];
            if (this.forceHideOrShow) {
                isHideOrShowOpts = this.forceHideOrShow === 'show';
            } else if (this.data) {
                isHideOrShowOpts = this.data.options.filter(val => val.checked).length > 0;
            } else if (this.value) {
                this.value.forEach(v => {
                    tempMap.push(v);
                });
            }
            return {
                isOptsShow: isHideOrShowOpts,
                checkboxMap: tempMap
            };
        },
        watch: {
            value (v) {
                this.checkboxMap = [];
                v.forEach(v => {
                    this.checkboxMap.push(v);
                });
            }
        },
        methods: {
            onIconClick () {
                this.isOptsShow = !this.isOptsShow;
            },
            handleFromChildren (label, checked) {
                if (checked) {
                    this.checkboxMap.push(label);
                } else {
                    let index = this.checkboxMap.findIndex(v => v === label);
                    this.checkboxMap.splice(index, 1);
                }
                this.$emit('check', this.checkboxMap);
            },
            getChildChecked (label) {
                return this.checkboxMap.includes(label);
            },
            check (e, key) {
                if (!this.$slots.default) {
                    const item = this.data.options[key];
                    this.$set(this.data.options[key], 'checked', e);
                    this.$emit('check', {group: this.data, item});
                }
            }
        },
        computed: {
            curStyle () {
                return {
                    'margin-left': this.marginLeft * this.$cStyle.horizonMargin + 'px',
                    'margin-right': this.marginRight * this.$cStyle.horizonMargin + 'px',
                    'float': this.float
                };
            },
            widthStyle () {
                return {
                    width: this.textWidth === -1 ? 'auto' : `${this.textWidth}px`
                };
            }
        },
        components: {
            CheckBox,
            NormalLabel
        },
        mounted () {
        }
    };
</script>

<template>
    <div class="check-box-group"
         :class="[theme, {disabled: disabled}]"
         :style="curStyle"
    >
        <template v-if="$slots.default">
            <slot></slot>
        </template>
        <template v-else>
            <normal-label
                    class="cbg-text"
                    :class="[{showed:isOptsShow}]"
                    :text="data.name"
                    :icon="icon"
                    @click.native="onIconClick"
                    marginLeft="0"
            ></normal-label>

            <div class="row cbg-row" v-show="isOptsShow">
                <check-box
                        v-for="(item, key) in data.options"
                        class="cbg-checkbox"
                        :key="key"
                        :class="[shape]"
                        :text="item.text"
                        :checked="item.checked"
                        @check="check($event,key)"
                        marginRight="1"
                ></check-box>
            </div>
        </template>
    </div>
</template>

<style lang="less">
    @import '../../assets/less/widgets-var.less';

    .check-box-group {
        width: auto;
        min-width: 1px;
        height: auto;
        text-align: center;
        padding: 0;
        margin: (@lineHeight - 36)/2 0;
        position: relative;
        cursor: pointer;

        .cbg-text {
            margin: 0;
            color: @otherTextClr;

            .icon {
                display: inline-block;
                transition: all ease 0.3s;
            }

            &.showed {
                .icon {
                    transform: rotate(90deg);
                }
            }
        }

        .cbg-checkbox {
            margin: 0;
        }

        .cbg-row {
            box-sizing: border-box;
            padding-left: 20px;
        }

    }

</style>
